import { render, staticRenderFns } from "./FunilList.vue?vue&type=template&id=644493e5&scoped=true"
import script from "./FunilList.vue?vue&type=script&lang=js"
export * from "./FunilList.vue?vue&type=script&lang=js"
import style0 from "./FunilList.vue?vue&type=style&index=0&id=644493e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644493e5",
  null
  
)

export default component.exports